<template>
    <div>
        <section>
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- last condition incase presenter started registering mates and didn't choose his own time slots -->
                            <div class="alert alert-danger error-summary" v-if="errors.length > 0 || $v.registration_form.$invalid == true || (available_slots.length < 1 && use_my_time_slots)">
                                <ul>
                                    <li class="text-danger" v-if=" !$v.registration_form.login_details.username.required ">Username field is required</li>
                                    <li v-if="!$v.registration_form.login_details.username.minLength" class="text-danger">Username must have at least 6 letters.</li>
                                    <li v-if="errors['username']" class="text-danger">{{ errors['username'] }}</li>
                                    <li v-if="!$v.registration_form.login_details.password.required"
                                    class="text-danger">Password field is required</li>
                                    <li v-if="!$v.registration_form.login_details.password.minLength"
                                    class="text-danger">Password must have at least 6 letters.</li>
                                    <li class="text-danger" v-if="available_slots.length < 1 && use_my_time_slots" >
                                        You haven't selected your own time slots, please select your time slots to be applied or choose times manually for this colleague
                                    </li>
                                    <li class="text-danger" v-if="!$v.registration_form.login_details.password_confirmation.sameAs">Passwords must be identical.</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.job_title.required">Job title field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.address.required">Address field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.country_id.required">Country field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.additional_email.email">Additional email is invalid email address</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.telephone.required">Telephone field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.mobile.required">mobile field is required</li>
                                    <li class="text-danger" v-if="!use_my_time_slots && !$v.registration_form.available_slot.required">Available slot field is required</li>
                                    <li class="text-danger" v-if="!use_my_time_slots && !$v.registration_form.mate_slots.required"> Slots in day required </li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.assistant_email.email">Assistant email is invalid email address</li>
                                </ul>
                            </div>

                            <fieldset class="fieldset-padding" >
                                <legend>Login Details</legend>
                                <p class="font-bold font-87" >Please create a Username and Password that you can use to access your personal registration information in the future, and then click the &quot;Submit&quot; button.</p>

                                <div class="row" >
                                    <div
                                        class="col-lg-4 col-sm-12"
                                        :class="{'has-error' : (form_options.enableLoginDetails ? ($v.registration_form.login_details.username.$invalid || errors['username']) : false)}"
                                    >
                                        <label class="font-bold font-8" > Username <span class="required">*</span></label>
                                        <input  v-model="registration_form.login_details.username" type="text" />
                                        <small class="text-danger" v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.username.required : false">Field is required</small>
                                        <small v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.username.minLength : false"
                                                class="text-danger">Username must have at least 6 letters.</small>
                                        <small v-if="errors['username']"
                                                class="text-danger">{{ errors['username'] }}</small>
                                    </div>

                                    <div
                                        class="col-lg-4 col-sm-12 "
                                        :class="{'has-error' : (form_options.enableLoginDetails ? $v.registration_form.login_details.password.$invalid : false)}"
                                    >
                                        <label class="font-bold font-8" > Password <span class="required">*</span></label>
                                        <input   v-model="registration_form.login_details.password" type="password" />
                                        <small v-if="!$v.registration_form.login_details.password.required"
                                                class="text-danger">Field is required</small>
                                        <small v-if="!$v.registration_form.login_details.password.minLength"
                                                class="text-danger">Password must have at least 6 letters.</small>
                                    </div>

                                    <div
                                        class="col-lg-4 col-sm-12"
                                        :class="{'has-error' : (form_options.enableLoginDetails ? $v.registration_form.login_details.password_confirmation.$invalid : false)}"
                                    >
                                        <label class="font-bold font-8" > Confirm Password <span class="required">*</span></label>
                                        <input  v-model="registration_form.login_details.password_confirmation" type="password" />
                                         <small class="text-danger" v-if="!$v.registration_form.login_details.password_confirmation.sameAs ">Passwords must be identical.</small>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset class="fieldset-padding" >
                                <legend>Personal Details</legend>

                                <div class="row">
                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-8" >Title</label>
                                        <input v-model="registration_form.client_details.title" disabled="" type="text" />
                                    </div>
                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-8" >First Name</label>
                                        <input v-model="registration_form.client_details.first_name" disabled="" type="text" />
                                    </div>
                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-8" >Middle Name</label>
                                        <input disabled="" v-model="registration_form.client_details.middle_name"  type="text" />
                                    </div>
                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-8" >Family Name</label>
                                        <input v-model="registration_form.client_details.family_name" disabled="" type="text" />
                                    </div>
                                    <div class="col-lg-6 col-sm-12" :class="{'has-error' : $v.registration_form.client_details.job_title.$invalid }" >
                                        <label class="font-bold font-8" > Job Title <span class="required">*</span></label>
                                        <input v-model="registration_form.client_details.job_title" type="text" />
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.job_title.required">Field is required</small>
                                    </div>
                                    <div class="col-lg-6 col-sm-12" >
                                        <label class="font-bold font-8" >Company</label>
                                        <input v-model="registration_form.client_details.company" disabled="" type="text" />
                                    </div>
                                    <div class="col-lg-12 col-sm-12" :class="{'has-error' : $v.registration_form.client_details.address.$invalid }">
                                        <label class="font-bold font-8" >Address <span class="required">*</span></label>
                                        <textarea v-model="registration_form.client_details.address"></textarea>
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.address.required">Field is required</small>
                                    </div>
                                    <div class="col-lg-12 col-sm-12" v-if="form_options.isInvestor" >
                                        <label class="font-bold font-8" >Biography (Company/Personal Bio) <span class="required">*</span></label>
                                        <textarea v-model="registration_form.client_details.biography"></textarea>
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.biography.required">Field is required</small>
                                    </div>

                                    <div class="col-lg-3 col-sm-12" :class="{'has-error' : $v.registration_form.client_details.country_id.$invalid }">
                                        <label class="font-bold font-8" >Country <span class="required">*</span></label>
                                        <select v-model="registration_form.client_details.country_id">
                                            <!-- <option :value="null">[Please Select]</option> -->
                                            <option v-for="country in lists.countries" :value="country.id" :key="country.id">{{ country.name }}</option>
                                        </select>
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.country_id.required">Field is required</small>
                                    </div>

                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-8" >E-mail <span class="required">*</span></label>
                                        <input disabled="" v-model="registration_form.client_details.email" type="text" />
                                    </div>

                                    <div class="col-lg-3 col-sm-12"  :class="{'has-error' : $v.registration_form.client_details.additional_email.$invalid }" >
                                        <label class="font-bold font-8" >Other E-mail</label>
                                        <input v-model="registration_form.client_details.additional_email" type="text" />
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.additional_email.email">Invalid email address</small>
                                    </div>
                                    <div class="col-lg-3 col-sm-12" :class="{'has-error' : $v.registration_form.client_details.telephone.$invalid }" >
                                        <label class="font-bold font-8" >Telephone <span class="required">*</span></label>
                                        <input v-model="registration_form.client_details.telephone" type="text" />
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.telephone.required">Field is required</small>
                                    </div>
                                    <div class="col-lg-3 col-sm-12" :class="{'has-error' : $v.registration_form.client_details.mobile.$invalid }" >
                                        <label class="font-bold font-8" >Mobile <span class="required">*</span></label>
                                        <input v-model="registration_form.client_details.mobile" type="text" />
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.mobile.required">Field is required</small>
                                    </div>
                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-7">Name of your Assistant (for contact purposes)</label>
                                        <input v-model="registration_form.client_details.assistant_name" type="text" />
                                    </div>
                                    <!-- <div class="clearfix" ></div> -->
                                    <div class="col-lg-3 col-sm-12" >
                                        <label class="font-bold font-8" >Assistant's Phone</label>
                                        <input v-model="registration_form.client_details.assistant_phone" type="text" />
                                    </div>
                                    <div class="col-lg-3 col-sm-12" :class="{'has-error' : $v.registration_form.client_details.assistant_email.$invalid }" >
                                        <label class="font-bold font-8" >Assistant's E-mail</label>
                                        <input v-model="registration_form.client_details.assistant_email" type="text" />
                                        <small class="text-danger" v-if="!$v.registration_form.client_details.assistant_email.email">Invalid email address</small>
                                    </div>
                                </div>
                                <table>
                                    <!-- <tr v-if="form_options.isInvestor">
                                        <td :class="{'has-error' : $v.registration_form.client_details.nationality_id.$invalid }">
                                            <label>Nationality <span class="required">*</span></label>
                                            <select v-model="registration_form.client_details.nationality_id">
                                                <option :value="null">[Please Select]</option>
                                                <option v-for="country in lists.countries" :value="country.id">{{ country.name }}</option>
                                            </select>
                                             <small class="text-danger" v-if="!$v.registration_form.client_details.nationality_id.required">Field is required</small>
                                        </td>
                                    </tr> -->
                                    <!-- <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.email_confirmation.$invalid }">
                                            <label>Confirm E-mail *</label>
                                            <input v-model="registration_form.client_details.email_confirmation" type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.email_confirmation.sameAs">Emails didnt match</small>
                                        </td>
                                    </tr> -->
                                    <!-- <tr>
                                        <td>
                                            <label>Fax</label>
                                            <input v-model="registration_form.client_details.fax" type="text" />
                                        </td>
                                    </tr> -->
                                </table>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm" style="padding-top:0px" >
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset class="fieldset-padding" >
                                <legend>Days of Attendance</legend>
                                <input v-model="use_my_time_slots" type="checkbox" />use Time slots an mine
                                <div v-if="!use_my_time_slots" class="custom-scroller" style="overflow:scroll" >
                                    <div class="row"  style="width:950px" >
                                        <div class="col-md-12">
                                            <p style="margin-top:1rem" >
                                                The meetings will be scheduled over 6 days, you are kindly requested to choose the two days that best suit your schedule, either 1-2 March or 3-4 March or 8-9 March so we can schedule your meetings accordingly. Please note that due to both the large number of companies scheduled to attend and the strong investor demand for meetings, we have reached the maximum capacity on 1-2 March at the moment, however the rest of the days are still available for scheduling.
                                            </p>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="font-87" >
                                            <b>Please select your time zone/city then select your time preferred time slots</b> <span class="required">*</span></label>
                                            <VueSelect
                                                style="display: block; margin-bottom: 1rem; width: 50%"
                                                placeholder="Select Time Zone"
                                                :options="this.timeZones"
                                                @input="changeTimeZone"
                                                :value="this.registration_form.timezone"
                                            ></VueSelect>

                                        </div>
                                        <div class="col-md-12">
                                            <div>
                                                <div v-for="group in groupedSlots" :key="group.groupNumber">
                                                    <div @click="selectGroup(group)">
                                                        <input v-model='selected_group' type='radio' style='margin-right:10px;margin-bottom:10px'
                                                        :value='group.groupNumber'>{{group.groupTitle}}
                                                    </div>
                                                    <div v-if='selected_group == group.groupNumber'>
                                                        <div style="margin-bottom:10px;display:flex" v-for="(val, date, index) in group.slots" :key="date">

                                                            <input v-model="registration_form.available_slot"  type="checkbox" :value="date"
                                                            :disabled="isSlotDisabled(index, date) || isInLateRegister(date)"
                                                            @change="selectPresenterSlot(date, $event)"> {{ val.formattedDate }}

                                                            <div style="display:flex;margin:0px 6px"  >
                                                                <div style="margin:0px 4px;">
                                                                    <input :checked="isAllSelected(val.timeslots)" :disabled="isSlotDisabled(index, date) || isInLateRegister(date)"
                                                                           @change="selectAllSlots($event,selected_group)" type="checkbox" style="margin:unset" :value="date" >
                                                                    <span> All </span>
                                                                </div>
                                                                <div style="margin:0px 4px" v-for="timeslot in val.timeslots" :key="'slotstart'+timeslot.start_time" >
                                                                    <input type="checkbox" :disabled="isSlotDisabled(index, date) || isInLateRegister(date)" style="margin:unset" v-model="registration_form.mate_slots" :value="timeslot.id" >
                                                                    <span> {{timeslot.start_time}} </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <small class="text-danger" v-if="!$v.registration_form.mate_slots.required">Slots are required</small>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm" style="padding-top:0px" >
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <input @click="submitRegisterMate" value="Register Colleague" type="submit" class="btn btn-outline-clr btn-sm" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
import { required, requiredIf ,sameAsPassword, sameAs, minLength, email, numeric, minValue } from 'vuelidate/lib/validators'
import Api from '@/Api'
import VueSelect from 'vue-select';
import _ from 'lodash';
var moment = require('moment');
var momentTZ = require('moment-timezone');

export default {
    name:"RegisterMates",
    props:[ 'clientData' , 'countryList' , 'available_slots' , 'time_zones' , 'grouped_slots' ],
    components: {
        VueSelect
    },
    data() {
        return {
            selected_group:0,
            groupedSlots:[],
            use_my_time_slots:true,
            timeZones:[],
            registration_form: {
                login_details: {
                    username: 'TestTest',
                    password: '',
                    password_confirmation: '',
                },
                client_details: {
                    first_name: '',
                    middle_name: '',
                    family_name: '',
                    title:'',
                    job_title: '',
                    company: '',
                    address: '',
                    country_id: '',
                    nationality_id: '',
                    email: '',
                    // email_confirmation: '',
                    additional_email: '',
                    telephone: '',
                    // fax: '',
                    mobile: '',
                    assistant_name: '',
                    assistant_phone: '',
                    assistant_email: '',
                },
                timezone: {label: '', code: ''},
                arrival_dates: {
                    arrival_date: '',
                    arrival_time: '',
                    departure_date: '',
                    departure_time: '',
                },
                available_slot:[],
                mate_slots:[],
                conference_dates: {},
                selected_group:0,
                remarks: '',
                prefer_interview:0
            },
            //form_options.datepicketSetup.disabledDates.to
            form_options: {
                enableRemarks: 1,
                disable_arrival_dates: false,
                disable_depature_dates: false,
                disable_login_details_area: true,
                isInvestor: false,
                isPresenter: false,
                enableLoginDetails:false,
                clientHasAppUser: true,
                datepicketSetup: {
                    disabledDates: {
                        to :null,
                        from :null
                    }
                }
            },
            lists: {
                countries: [],
                agenda_slots: [],
                closed_days:[],
                closed_conference_days:[],
            },
            conference: {},
            remaining_timer: '00:00',
            errors: {}
        };
    },
    validations() {
        let rules = {
          registration_form: {
            login_details: this.loginDetailsRules,
            client_details: this.clientDetailsRules,
          }
        }
        if( !this.use_my_time_slots )
        {
            rules.registration_form['mate_slots'] ={required};
            rules.registration_form['available_slot'] ={required};
        }
        return rules;
    },
    methods: {
        isSlotDisabled(index, date){
            if(!this.selected_group)
                return false;
            // _.keys(this.lists.agenda_slots);
            if(this.registration_form.available_slot.includes(date))
                return false;
            const dayNumber = this.registration_form.conference_dates[date];
            let slotGroup = Math.ceil((dayNumber) / this.conference.split_days);
            return slotGroup !== this.selected_group;
        },
        isInLateRegister(date){
            const lateRegisterAvailableSLots = localStorage.getItem('lateRegisterAvailableSLots')
            let lateRegisterList;
            if(lateRegisterAvailableSLots && lateRegisterAvailableSLots != 'undefined') {
                lateRegisterList = JSON.parse(lateRegisterAvailableSLots);
            }
            if(!lateRegisterList || _.isEmpty(lateRegisterList)) return false;
            return true ;
        },
        selectPresenterSlot(date, ev){
            if(ev == true || ev.target.checked){
                const dayNumber = this.registration_form.conference_dates[date];
                this.selected_group = Math.ceil(dayNumber / this.conference.split_days)
            }else{
                if(!(this.registration_form && this.registration_form && this.registration_form.available_slot && this.registration_form.available_slot.length))
                    this.selected_group = 0;
            }
        },
        selectGroup(group){
            this.registration_form.available_slot = [];
            this.registration_form.mate_slots = [];
            _.each(group.slots, (slots,date)=>{
                this.registration_form.available_slot.push(date);
            });
        },
        initClientDataIntoForm(){

            let client = this.clientData.client;

            this.registration_form.client_details = {
                first_name: client.first_name,
                middle_name: client.middle_name,
                family_name: client.family_name,
                title: client.title.name,
                job_title: client.job_title,
                company: client.company.name,
                address: client.address,
                country_id: client.country_id,
                nationality_id: client.nationality_id,
                email: client.email,
                // email_confirmation: client.email_confirmation,
                additional_email: client.additional_email,
                telephone: client.telephone,
                // fax: client.fax,
                mobile: client.mobile,
                assistant_name: client.assistant_name,
                assistant_phone: client.assistant_phone,
                assistant_email: client.assistant_email,
                company_id: client.company_id,
                client_type_id: client.client_type_id,
                biography: client.biography
            };

            this.registration_form.login_details.username = client.user ? client.user.username : '';
            this.registration_form.available_slot = this.available_slots;
            this.registration_form.mate_slots = this.clientData.presenter_property.available_slot.map(slot => parseInt(slot,10));

            this.registration_form.timezone = this.clientData.timezone ?  {label: this.clientData.timezone + " (GMT"+momentTZ.tz(this.clientData.timezone).format('Z')+")", code: this.clientData.timezone} : {label: '',code: ''};
        },
        initLists()
        {
            this.lists.countries = _.orderBy(this.countryList, [c => c.name.toLowerCase()]);
        },
        submitRegisterMate()
        {
            if( this.$v.registration_form.$invalid === true || (this.available_slots.length < 1 && this.use_my_time_slots) )
            {
                this.validate();
                return;
            }
            let data = this.setupPresenterMatesRegistrationDataRequest( this.registration_form );
            console.log("data" , data );
            Api().post('auth/register-presenter-mate' , data )
                 .then( response => {
                    this.$emit("mate-registered" , response.data.client);
                    this.$toastr.s("SUCCESS MESSAGE","Colleague Registered Successfully");
                 })
                 .catch( err => {
                    console.log(err.response);
                 })
        },
        setupPresenterMatesRegistrationDataRequest(mateData)
        {
            let data = {
                client_id : this.clientData.client.id,
                ...mateData.login_details,
                ...mateData.client_details,
                available_slot: this.use_my_time_slots ? this.available_slots : mateData.mate_slots,
                timezone: this.registration_form.timezone.code
            };
            return _.omit(data, ['first_name' , 'middle_name' ,'family_name', 'company' , 'company_id' , 'country_id' , 'email' , 'nationality_id' , 'title']);
        },
        changeTimeZone({ code, label }) {
            this.groupedSlots = this.groupedSlots.map( group => {
                let dates = Object.keys( group.slots);
                for(let i= 0 ; i < dates.length ; i++)
                {
                    group.slots[dates[i]].timeslots.map(slot =>{
                        const startTime = slot.start_time.replace(/\(.+\)/, '');
                        slot.start_time = this.convertTimeZone(`${slot.date} ${startTime}`, this.registration_form.timezone.code || 'Asia/Saudi Arabia', code);
                        return slot;
                    });
                }
                return group;
            });
            this.registration_form.timezone.code = code;
            this.registration_form.timezone.label = label;
        },
        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format('L');
            time.tz('Asia/Saudi Arabia');
            const londonTime = time.format('L');
            time.tz(newTimeZone);
            const newTime = time.format('L');
            const diff = moment(newTime).diff(moment(londonTime), 'days');
            let res = time.format("HH:mm");
            if(diff) {
                res += '(' + (diff > 0 ? '+' : '') + diff + ')';
            }
            return res;
        },
        isAllSelected(timeSlots){
            const timeSlotsId  = timeSlots.map(slot => slot.id);
            const intersectionLength =  _.intersection(  this.registration_form.mate_slots , timeSlotsId).length;
            return intersectionLength === timeSlotsId.length ;
        },
        selectAllSlots(e,selected_group) {
            let el = e.target;
            let date = el.value;
            let group = this.groupedSlots.filter(group => group.groupNumber === selected_group)[0];
            let slots = group.slots[date].timeslots;
            let slots_ids = slots.map(slot => slot.id);

            if(el.checked == true)
            {
                this.registration_form.mate_slots = _.uniq([...this.registration_form.mate_slots, ...slots_ids]);
            }
            else {
                this.registration_form.mate_slots = this.registration_form.mate_slots.filter( item => !slots_ids.includes(item));
            }
        },
         validate() {
            this.$v.$touch();
            this.$nextTick(() => {
                 this.scrollToFirstError();
            });
        },
        scrollToFirstError() {
            let domRect = document.querySelector('.error-summary,.has-error').getBoundingClientRect();
            window.scrollTo(
                domRect.left + document.documentElement.scrollLeft,
                domRect.top + document.documentElement.scrollTop - 255

            );
        },
        mapSelectedGroup(groupedSlots , available_dates)
        {
            this.groupedSlots.forEach(group =>{
                let keys =  Object.keys(group.slots);
                if(_.intersection(available_dates,keys).length >= 1)
                {
                    this.selected_group = group.groupNumber;
                    this.registration_form.available_slot = available_dates;
                }
            });
        }
    },
    created(){
        this.timeZones = this.time_zones;
        this.groupedSlots = this.grouped_slots;
        if(this.clientData)
        {
            this.initClientDataIntoForm();
            this.initLists();
            this.mapSelectedGroup( this.grouped_slots , this.clientData.available_slot);
        }
    },
    computed: {
        loginDetailsRules() {
            return {
                username: {required, minLength:minLength(6)},
                password : { required, minLength:minLength(6) },
                password_confirmation : { sameAs: sameAs('password') },
            };
        },
        clientDetailsRules() {
            const rules = {
                job_title: {required},
                address: {required},
                country_id: {required},
               /* email: {required, email},
                email_confirmation: {sameAs: sameAs('email')},*/
                additional_email: {email},
                telephone: {required},
                mobile: {required},
                assistant_name: '',
                assistant_phone: {},
                assistant_email: {email}
            }
            return rules;
        }
    }
}
</script>

<style scoped>
    .custom-scroller::-webkit-scrollbar {
        width:1px;
        height:1px;
    }

    .custom-scroller::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 0px white;
    }
</style>
